export enum UserCertificationUpdateProgressActions {
    acceptHonestyPolicy = 'honesty-policy',
    currentLesson = 'current-lesson',
    completeLesson = 'complete-lesson',
    completeCertificate = 'complete-certification',
}
